import React, { useState } from 'react';
import { Badge, Button, Empty, Popover } from 'antd';
import { BellOutlined } from '@ant-design/icons';

const formatDate = (iso) =>
    new Date(iso).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' });

const MessageList = ({ messages }) => {
    if (!messages.length) {
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No messages" />;
    }
    return (
        <div className="message-list">
            {messages.map((m) => (
                <div key={m.id} className={m.read ? 'message-item' : 'message-item message-unread'}>
                    <div className="message-title">{m.title}</div>
                    {m.body && <div className="message-body">{m.body}</div>}
                    <div className="message-date">{formatDate(m.show_from)}</div>
                </div>
            ))}
        </div>
    );
};

// Bell in the header with an unread count; click opens the inbox.
const MessageBell = ({ messages, unreadCount, markRead }) => {
    const [open, setOpen] = useState(false);

    const handleOpenChange = (next) => {
        setOpen(next);
        // mark as read on close, so unread items stay highlighted while the inbox is open
        if (!next) markRead(messages.filter((m) => !m.read).map((m) => m.id));
    };

    return (
        <Popover
            trigger="click"
            placement="bottomRight"
            title="Messages"
            open={open}
            onOpenChange={handleOpenChange}
            content={<MessageList messages={messages} />}
        >
            <span data-help-id="messages-bell">
                <Badge count={unreadCount} size="small" offset={[-4, 4]}>
                    <Button shape="circle" className="header-button" icon={<BellOutlined />} title="Messages" />
                </Badge>
            </span>
        </Popover>
    );
};

export default MessageBell;
